module.exports = __webpack_public_path__ + "img/monaco.818adec2.png";